import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private sessionStorage: Storage;
  private readonly twoFactorAuthenticationToken: string;
  private readonly userToken: string;
  private readonly isValid: string;

  constructor() {
    this.sessionStorage = window.sessionStorage;
    this.twoFactorAuthenticationToken = 'twoFactorAuthenticationToken';
    this.userToken = 'userToken';
    this.isValid = 'validUser';
  }

  public clear(): any {
    this.sessionStorage.clear();
  }

  private getObject(key: string): any {
    const value = this.sessionStorage.getItem(key);
    return JSON.parse(value);
  }

  public getTwoFactorAuthenticationToken(): any {
    return this.getObject(this.twoFactorAuthenticationToken);
  }

  public getUserToken(): any {
    return this.getObject(this.userToken);
  }

  public getInvalidUser(): any {
    return this.getObject(this.isValid);
  }

  private setObject(key: string, value: any): void {
    this.sessionStorage.setItem(key, JSON.stringify(value));
  }

  public setTwoFactorAuthenticationToken(
    twoFactorAuthenticationToken: string
  ): any {
    return this.setObject(
      this.twoFactorAuthenticationToken,
      twoFactorAuthenticationToken
    );
  }

  public setUserToken(userToken: string): any {
    return this.setObject(this.userToken, userToken);
  }

  public setInvalidUser(): any {
    return this.setObject(this.isValid, true);
  }
}
